import { styled } from "@mui/material";
import { Typography as MuiTypography } from "@mui/material";

export const TitleContainer = styled("div")(({ theme }) => ({
  maxWidth: "620px",
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
  alignSelf: "stretch",
  gap: theme.space._500,
}));

export const TitleTypography = styled(MuiTypography)(({ theme }) => ({
  fontFamily: theme.fonts.default,
  fontSize: theme.fontSizes["8xl"],
  fontWeight: theme.fontWeights.bold,
  lineHeight: theme.lineHeights.slim,

  color: theme.colors.white,

  "@media (max-width: 600px)": {
    minHeight: 0,
    fontSize: theme.fontSizes["6xl"],
  },
}));


export const SubtitleTypography = styled(MuiTypography)(({ theme }) => ({
  fontFamily: theme.fonts.default,
  fontSize: theme.fontSizes.lg,
  fontWeight: theme.fontWeights.regular,
  lineHeight: theme.lineHeights.tall,
  whiteSpace: "pre-wrap",

  color: theme.colors["neutral.500"],
})) as typeof MuiTypography;

export const PageContainer = styled("div")(({ theme }) => ({
  position: "relative",

  display: "flex",
  flexDirection: "column",
  width: "100%",
  marginLeft: "auto",
  marginRight: "auto",
  marginTop: `8rem`,
  gap: theme.space._700,
  padding: `0 ${theme.space._900} ${theme.space._900} ${theme.space._900}`,
  
  "@media (max-width: 600px)": {
    padding: `0 ${theme.space._400} ${theme.space._400} ${theme.space._400}`,
  },
}));